import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleAttachDocumentsToElement(
  task: Identifiable<Task>,
  { elementId, documents }: Boundaries["attachDocumentsToElement"]["success"],
): Identifiable<Task> {
  return elementId === task.uuid
    ? {
        ...task,
        attachmentsNbr: task.attachmentsNbr
          ? task.attachmentsNbr + documents.length
          : task.attachmentsNbr,
      }
    : task;
}

export { handleAttachDocumentsToElement };
